import L from 'leaflet';

import {linkedtpArray, ClearShowingLinkedObjects, ClearShowingAllLinkedObjects, SetActiveFiderLineId, 
  ShowFiderOnMap, GetActiveFiderLineId, HideFider } from './PPManager';
import {PolePopupSetup, UnLoadAllPoles} from './PoleManager.js'
import {map, MarkerClick, OpenSideBar, PopupBehavior, SetCurrentBottomSheet, HighlightLine, ClearLineHighlight } from './Main.js'
import {DrawMainMarker, DrawPoleMarker, ClearPoleMarkersArray, SetLastInsertedMarker, DrawDecorativeMarker} from './MarkerManager.js'
import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import {GetUserPermissions, GetUserId, GetUserName, isMobileVersion, DeleteObjectWithConfirm} from './Main.js'
import ModalWrap from "./../react-components/modal/ModalWrap";
import DeleteModal from "./../react-components/modal/delete/DeleteModal";

import { LineBottomSheet } from '../react-components/mobile/LineBottomSheet';

//export var polylineArray = [];

export const linesData = {
  polylineArray: []
};

var lastOpenedPopup = null;

/*export function ClearPolyline() {
  linesData.polylineArray = [];
}*/

function addSafeListener(id, handler) {
  const el = document.getElementById(id);
  if (!el) return;
  const clone = el.cloneNode(true);
  el.replaceWith(clone);
  clone.addEventListener('click', handler);
}

export function LoadAllLines() {
    UnLoadAllLines();
    //fetch(`${process.env.REACT_APP_BASE_URL}/lines_list`)
    fetch(`${process.env.REACT_APP_BASE_URL}/api/lines_list/loadAllLines`)
          .then(response => response.json())
          .then(lines => {

            // Взаимодействие со всеми имеющимися линиями
            lines.forEach(line => {

              var foundObject = linkedtpArray.find(function(mainObject) {
                return mainObject.name === line.linkedtp;
              });
              if (foundObject == null) {
                  var ppObject = {
                    id: 0,
                    name: line.linkedtp,
                    children: [],
                    lines: []
                  };
                foundObject = ppObject;
                linkedtpArray.push(ppObject);
              }

              const {id, from_id, to_id, linkedtp, start_lat, start_lng, end_lat, end_lng, typecode, start_name, end_name } = line;

              // приствоение точек начала и конца линии
              const startPoint = L.latLng(start_lat, start_lng);
              const endPoint = L.latLng(end_lat, end_lng);

              // Изменение стиля линии в зависимости от типа линии в переменной type
              const lineStyle = typecode == 7 ? { dashArray: '7, 7', color: 'red', id: id, from_id: from_id, to_id: to_id, linkedtp: linkedtp, start_name: start_name, end_name: end_name } 
                : { color: 'red', id: id, from_id: from_id, to_id: to_id, linkedtp: linkedtp, start_name: start_name, end_name: end_name };

              // Создание Polyline между startPoint и endPoint со стилем type
              const polyline = L.polyline([startPoint, endPoint], lineStyle).addTo(map);
			        linesData.polylineArray.push(polyline);		

              var childObject1_1 = {
                id: line.id,
                line: polyline,
                start_name: line.start_name,
                end_name: line.end_name,
                from_id: from_id,
                to_id: to_id
              };

              
              
              if (foundObject) {
               
                foundObject.lines.push(childObject1_1);
              } else {
              //  console.log('Объект с указанным именем не найден');
              }

              
              LinePopupSetup(polyline, start_name, end_name, linkedtp, typecode);
             // LinePopupBehavior(polyline, line.id, line.typecode);
              
            });
          })
          .catch(error => {
            console.error('Error:', error);
          });
}

export function UnLoadAllLines() {
    linkedtpArray.forEach(foundObject => { 
        foundObject.lines.forEach(object => { 
            object.line.remove();

            var polylineIndex = -1;
            for (var i = 0; i < linesData.polylineArray.length; i++) {
                if (linesData.polylineArray[i].options.id === object.id) {
                    polylineIndex = i;
                break;
            }
            }

            // Если полилиния найдена, удалите её из массива
            if (polylineIndex !== -1) {
                /*var removedPolyline = */linesData.polylineArray.splice(polylineIndex, 1);
                
            } else {
              //  console.log('Полилиния с указанным id не найдена');
            }
            
        });
        foundObject.lines = [];
    });
    
}


export function AddCurveLine({ coords, from_id, to_id, typecode, linkedtp, start_name, end_name }) {

  const geojson = {
  type: 'LineString',
  coordinates: coords // [ [lng, lat], ... ]
};

var lineId;

  fetch(`${process.env.REACT_APP_BASE_URL}/api/lines_list/insertCurveLine`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      from_id, to_id, typecode, linkedtp,
      geom: geojson,
      start_name,              
      end_name,               
      userId: GetUserId(),      
      username: GetUserName()   
    })
  })
  .then((res) => {
    if (!res.ok) {
      return res.json().then((errData) => {
        throw new Error(errData.error || `Ошибка сервера: ${res.status}`);
      });
    }
    return res.json();
  })
  .then(response => {

    lineId = response.id;
    const latlngs = coords.map(c => [c[1], c[0]]);


    const lineStyle = typecode == 7 ? { dashArray: '7, 7', color: 'black', id: lineId, from_id: from_id, to_id: to_id, linkedtp: linkedtp, start_name: start_name, end_name: end_name} 
              : { color: 'black', id: lineId, from_id: from_id, to_id: to_id, linkedtp: linkedtp, start_name: start_name, end_name: end_name };

    const polyline = L.polyline(latlngs, lineStyle/*{
      color: 'green',
      id: response.id
    }*/).addTo(map);

    linesData.polylineArray.push(polyline);

    var childObject1_1 = {
                id: lineId,
                line: polyline,
                start_name: start_name,
                end_name: end_name,
                from_id: from_id,
                to_id: to_id
              };

              // Используем метод find() для поиска объекта по имени
              var foundObject = linkedtpArray.find(function(mainObject) {
                return mainObject.name === linkedtp;
              });
              
              if (foundObject) {
               
                foundObject.lines.push(childObject1_1);
              } else {
             //  console.log('Объект с указанным именем не найден');
              }

            LinePopupSetup(polyline, start_name, end_name, linkedtp, typecode);
           // LinePopupBehavior(polyline, lineId, typecode);
  })
  .catch(err => {
    console.error(err);
    alert(`Не удалось добавить линию: ${err.message}`); // ← показываем пользователю
  });
}

export function AddLine(from_id, to_id, typecode, start_lat, start_lng, end_lat, end_lng, linkedtp, start_name, end_name) {
  const startPoint = L.latLng(start_lat, start_lng);
  const endPoint = L.latLng(end_lat, end_lng);
  var lineId;
  // Посылание информации на сервер методом POST
  //fetch(`${process.env.REACT_APP_BASE_URL}/lines_list`, {
  fetch(`${process.env.REACT_APP_BASE_URL}/api/lines_list/insertLine`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      from_id, to_id, typecode, 
      start_lat, start_lng, end_lat, end_lng, 
      linkedtp,
      start_name,              // нужно для entity_name на бэкенде
      end_name,                
      userId: GetUserId(),      
      username: GetUserName()
    })
    })
    .then((response) => {
    if (!response.ok) {
      return response.json().then((errData) => {
        throw new Error(errData.error || `Ошибка сервера: ${response.status}`);
      });
    }
    return response.json();
  })
    .then(response => {
      //  response.json().then(response => {         
            lineId = response.id;

            const lineStyle = typecode == 7 ? { dashArray: '7, 7', color: 'black', id: lineId, from_id: from_id, to_id: to_id, linkedtp: linkedtp, start_name: start_name, end_name: end_name} 
              : { color: 'black', id: lineId, from_id: from_id, to_id: to_id, linkedtp: linkedtp, start_name: start_name, end_name: end_name };
            const polyline = L.polyline([startPoint, endPoint], lineStyle).addTo(map);
            linesData.polylineArray.push(polyline);

            var childObject1_1 = {
                id: lineId,
                line: polyline,
                start_name: start_name,
                end_name: end_name,
                from_id: from_id,
                to_id: to_id
              };

              // Используем метод find() для поиска объекта по имени
              var foundObject = linkedtpArray.find(function(mainObject) {
                return mainObject.name === linkedtp;
              });
              
              if (foundObject) {
              
                foundObject.lines.push(childObject1_1);
              } else {
              //  console.log('Объект с указанным именем не найден');
              }

            LinePopupSetup(polyline, start_name, end_name, linkedtp, typecode);
           // LinePopupBehavior(polyline, lineId, typecode);
                    
       //   }) 
    })
  .catch(error => {
        console.error('Ошибка добавления линии: ', error);
        alert(`Не удалось добавить линию: ${error.message}`);
  });  
}

export function LinePopupSetup(polyline, start_name, end_name, linkedtp, typecode) {
  var isEditable = false;
  var departmentAccessArray = GetUserPermissions();
  
    const entry = departmentAccessArray.find(entry => {
      if (linkedtp === null) {
          return entry.startsWith("00=");
      } else {
          return entry.startsWith(linkedtp.substring(0, 2) + "=") || entry.startsWith("00=");
      }
  });
    if (entry) {
      // Если строка найдена, получаем значение
      const value = entry.split("=")[1];
      switch (value) {
        case '1':
        case '2':
          isEditable = true;
        
          break;
        case '3':
          isEditable = false;
          break;
      }
    }
  

  var editButtons = `<button id="fider${polyline.options.id}" class="simple_button">Показать схему только данного фидера</button><button id="deleteLine${polyline.options.id}" class="simple_button">Удалить Линию</button><button id="passport${polyline.options.id}" class="simple_button">Паспорт</button>`;

    if (/*GetUserName() === 'azhalpakov' || isMobileVersion ||*/ !isEditable) {
      editButtons = `<button id="fider${polyline.options.id}" class="simple_button">Показать схему только данного фидера</button><button id="deleteLine${polyline.options.id}" class="simple_button" style="display: none;">Удалить Линию</button><button id="passport${polyline.options.id}" class="simple_button">Паспорт</button>`;
    }
  // Привяжите событие popupopen к маркеру
  polyline.off('click');
  polyline.on('click', function (e) {
    if (isMobileVersion) {
    HighlightLine(polyline);
    const container = document.createElement('div');
    document.body.appendChild(container);
    SetCurrentBottomSheet(container);

    const handleClose = () => {
      ReactDOM.unmountComponentAtNode(container);
      container.remove();
      ClearLineHighlight(polyline);
    };

    const handleDelete = () => {
      const handeleDeleteConfirmed = () => {
        fetch(`${process.env.REACT_APP_BASE_URL}/api/lines_list/deleteLine`, {
          method: 'DELETE',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: polyline.options.id,
            deletedByUserId: GetUserId(),
            deletedByUsername: GetUserName(),
            entityName: `${polyline.options.start_name} - ${polyline.options.end_name}`
          })
        }).then((response) => {
          if (!response.ok) {
            return response.json().then((errData) => {
              throw new Error(errData.error || `Ошибка сервера: ${response.status}`);
            });
          }
          map.removeLayer(polyline);
          var polylineIndex = linesData.polylineArray.findIndex(p => p.options.id === polyline.options.id);
          if (polylineIndex !== -1) linesData.polylineArray.splice(polylineIndex, 1);
        }).catch(error => {
          console.error('Ошибка удаления линии:', error);
          alert(`Не удалось удалить линию: ${error.message}`);
        });
      };

      const modalContainer = document.createElement('div');
      document.body.appendChild(modalContainer);

      const handleModalClose = () => {
        ReactDOM.unmountComponentAtNode(modalContainer);
        modalContainer.remove();
      };

      ReactDOM.render(
        <ModalWrap>
          <DeleteModal handeleDelete={handeleDeleteConfirmed} set={handleModalClose} />
        </ModalWrap>,
        modalContainer
      );
    };

    ReactDOM.render(
      <LineBottomSheet
        startName={polyline.options.start_name}
        endName={polyline.options.end_name}
        linkedtp={polyline.options.linkedtp}
        isEditable={isEditable}
        isFiderActive={GetActiveFiderLineId() === polyline.options.id}
        onClose={handleClose}
        onDelete={handleDelete}
        onPassport={() => {
          MarkerClick(typecode, polyline.options.id, `${polyline.options.start_name} - ${polyline.options.end_name}`, false, false);
          OpenSideBar(true);
        }}
        onShowFider={() => ShowFiderOnMap(polyline.options.id)}
        onHideFider={() => HideFider()}
      />,
      container
    );
    return;
  }

    const latLng = map.mouseEventToLatLng(e.originalEvent);
    var popupContent = `<b>Линия: ${polyline.options.start_name} - ${polyline.options.end_name}</b><br><b>${polyline.options.linkedtp}</b><br>${editButtons}`;
    var myDiv = document.createElement('div');
    
    myDiv.innerHTML = popupContent;
    var popup = L.popup()
                .setContent(myDiv)
                .setLatLng(latLng)
                .openOn(map);       

    lastOpenedPopup = popup;

    // Выделяем после openOn: он закрывает предыдущий попап, и если это был попап
    // этой же линии, его 'remove' снял бы только что поставленное выделение
    HighlightLine(polyline);
    popup.on('remove', () => ClearLineHighlight(polyline));

    addSafeListener(`deleteLine${polyline.options.id}`, function () {
      const handeleDelete = (event) => {
        // Посылание информации на сервер методом DELETE
        //fetch(`${process.env.REACT_APP_BASE_URL}/lines_list/${lineId}`, {
        fetch(`${process.env.REACT_APP_BASE_URL}/api/lines_list/deleteLine`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: polyline.options.id,
          deletedByUserId: GetUserId(),
          deletedByUsername: GetUserName(),
          entityName: `${polyline.options.start_name} - ${polyline.options.end_name}`
        })
        })
        .then((response) => {
            if (!response.ok) {
              return response.json().then((errData) => {
                throw new Error(errData.error || `Ошибка сервера: ${response.status}`);
              });
            }

            map.removeLayer(polyline);

            var polylineIndex = -1;
            for (var i = 0; i < linesData.polylineArray.length; i++) {
            if (linesData.polylineArray[i].options.id === polyline.options.id) {
                polylineIndex = i;
                break;
            }
            }

            // Если полилиния найдена, удалите её из массива
            if (polylineIndex !== -1) {
                var removedPolyline = linesData.polylineArray.splice(polylineIndex, 1);

            } else {
             //   console.log('Полилиния с указанным id не найдена');
            }

            if (lastOpenedPopup) {
              map.closePopup(lastOpenedPopup);
            }

            console.log(`Линия ${polyline.options.id} успешно удалена`);
        })
        .catch(error => {
            console.error(`Ошибка удаления линии ${polyline.options.id}:`, error);
            alert(`Не удалось удалить линию: ${error.message}`);
        });
      };

        const container = document.createElement('div');
      document.body.appendChild(container);
     // SetCurrentBottomSheet(container);
      const handeleClose = (event) => {
        ReactDOM.unmountComponentAtNode(container);
        container.remove();
        //container = null;
      };
      // Отображаем React компонент в контейнере

      ReactDOM.render(<ModalWrap>
        <DeleteModal handeleDelete={handeleDelete} set={handeleClose}/>
      </ModalWrap>, container);
    });
    MarkerClick(typecode, polyline.options.id, 'test', false, false);
  //  document.getElementById(`passport${lineId}`).addEventListener('click', function() {
  addSafeListener(`passport${polyline.options.id}`, function () {
          //ShowPassport(objectId, latlng, circle);
          //MarkerClick(typecode, objectId);
          OpenSideBar(true);
        });

      //  document.getElementById(`fider${lineId}`).addEventListener('click', function() {
      addSafeListener(`fider${polyline.options.id }`, function () {
        SetActiveFiderLineId(polyline.options.id);
        //  document.getElementById('ShowAllObjects').checked = false;
        //  showAllObjectsByZoom = false;
          UnLoadAllPoles();
          UnLoadAllLines();
          ClearShowingLinkedObjects();
          ClearShowingAllLinkedObjects();

          fetch(`${process.env.REACT_APP_BASE_URL}/api/objects_list/load_fider_by_line_id/${polyline.options.id}`, {
              method: 'GET'
              })
            .then(response => response.json())
            .then(data => {
              
                data.forEach(object => { 
          
                    const latlng = L.latLng(object.lat, object.lng);
                   // const circle = DrawPoleMarker([object.lat, object.lng], object.typecode.toString(), object.countPlafond, object.name, 1, 2, object.textPosition, null, object.id, object.linkedtp).addTo(map);
                    var circle;
                  
                      circle = DrawPoleMarker(latlng, object.typecode.toString(), /*object.countPlafond*/null, object.name, 1, 2, object.textPosition, null, object.id, object.linkedtp).addTo(map);
                      PolePopupSetup(circle, object.name, object.linkedtp, object.lat, object.lng, object.id);
                    
          
                    //PolePopupSetup(circle, object.name, object.linkedtp, object.lat, object.lng, object.id);
                    PopupBehavior(circle, object.id, latlng, object.linkedtp, object.typecode, object.name);
          
                    var childObject1_1 = {
                        id: object.id,
                        name: object.name,
                        circle: circle,
                        typecode: object.typecode,
                        latlng: latlng
                      };
          
                      // Используем метод find() для поиска объекта по имени
                      var foundObject = linkedtpArray.find(function(mainObject) {
                        return mainObject.name === object.linkedtp;
                      });
                      
                      if (foundObject) {
                       
                        foundObject.children.push(childObject1_1);
                      } else {
                     
                        var ppObject = {
                              id: 0,
                              name: object.linkedtp,
                              children: [],
                              lines: []
                            };
                          foundObject = ppObject;
                          linkedtpArray.push(ppObject);
                          foundObject.children.push(childObject1_1);
                      }
          
                    
                });
            })


          fetch(`${process.env.REACT_APP_BASE_URL}/api/lines_list/load_fider_by_line_id/${polyline.options.id}`, {
  method: 'GET'
})
  .then(response => response.json())
  .then(data => {

    data.forEach(line => {
      const {
        id, from_id, to_id, linkedtp,
        typecode, start_name, end_name,
        voltage_class, geojson
      } = line;

      // Парсим координаты из GeoJSON
      const geo = JSON.parse(geojson);
      const latlngs = geo.coordinates.map(c => [c[1], c[0]]); // Переворачиваем [lng, lat] в [lat, lng]

      // Определяем цвет линии по классу напряжения
      let line_color = 'black';
      switch (voltage_class) {
        case 128: line_color = 'orange'; break;
        case 129: line_color = 'yellow'; break;
        case 130: line_color = 'red';    break;
        case 131: line_color = 'green';  break;
        case 133: line_color = 'purple'; break;
        case 134: line_color = 'blue';   break;
        default:  line_color = 'black';  break;
      }

      // Настраиваем стиль
      const lineStyle = {
        color: line_color,
        id: id,
        from_id: from_id,
        to_id: to_id,
        linkedtp: linkedtp,
        start_name: start_name,
        end_name: end_name,
        ...(typecode == 7 && { dashArray: '7, 7' })
      };

      // Рисуем полилинию на карте
      const polyline = L.polyline(latlngs, lineStyle).addTo(map);
      linesData.polylineArray.push(polyline);

      // Формируем объект для дерева/списка связанных объектов
      const childObject1_1 = {
        id: polyline.options.id,
        line: polyline,
        start_name: start_name,
        end_name: end_name,
        from_id: from_id,
        to_id: to_id
      };

      // Ищем родительский объект по имени linkedtp
      let foundObject = linkedtpArray.find(mainObject => mainObject.name === linkedtp);

      if (foundObject) {
        foundObject.lines.push(childObject1_1);
      } else {
        console.warn(`Объект с именем ${linkedtp} не найден в дереве. Создаем новый узел.`);
        const ppObject = {
          id: 0,
          name: linkedtp,
          children: [],
          lines: [childObject1_1]
        };
        linkedtpArray.push(ppObject);
      }

      // Привязываем попап и поведение клика по линии
      LinePopupSetup(polyline, start_name, end_name, linkedtp, typecode);
      //LinePopupBehavior(polyline, polyline.options.id, typecode);
    });
  })
  .catch(error => {
    console.error("Ошибка при загрузке и отрисовке линий фидера:", error);
  });


        });
    
  });
/*// Создание popup с информацией о линии и возможностью ее удаления
  const popupContentLine = `Линия : ${start_name} - ${end_name}<br>номер ШУНО линии: ${linkedtp}<br><button id="deleteLine">Удалить Линию</button>`;
  polyline.bindPopup(popupContentLine);*/
}

/*export function LinePopupBehavior(polyline, lineId, typecode) {
  polyline.on('click', function () {
   // document.getElementById(`deleteLine${lineId}`).addEventListener('click', function () {
   addSafeListener(`deleteLine${lineId}`, function () {
      const handeleDelete = (event) => {
        map.removeLayer(polyline);
        // Посылание информации на сервер методом DELETE
        //fetch(`${process.env.REACT_APP_BASE_URL}/lines_list/${lineId}`, {
        fetch(`${process.env.REACT_APP_BASE_URL}/api/lines_list/deleteLine`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineId})
        })
        .then(response => {
            
            var polylineIndex = -1;
            for (var i = 0; i < linesData.polylineArray.length; i++) {
            if (linesData.polylineArray[i].options.id === lineId) {
                polylineIndex = i;
                break;
            }
            }

            // Если полилиния найдена, удалите её из массива
            if (polylineIndex !== -1) {
                var removedPolyline = linesData.polylineArray.splice(polylineIndex, 1);
                console.log('Удалена полилиния:', removedPolyline[0]);
            } else {
                console.log('Полилиния с указанным id не найдена');
            }

            if (lastOpenedPopup) {
              map.closePopup(lastOpenedPopup);
            }

            console.log(`Линия ${lineId} успешно удалена`);
        })
        .catch(error => {
            console.error(`Ошибка удаления линии ${lineId}:`, error);
        });
      };

        const container = document.createElement('div');
      document.body.appendChild(container);
      const handeleClose = (event) => {
        ReactDOM.unmountComponentAtNode(container);
        container.remove();
        //container = null;
      };
      // Отображаем React компонент в контейнере

      ReactDOM.render(<ModalWrap>
        <DeleteModal handeleDelete={handeleDelete} set={handeleClose}/>
      </ModalWrap>, container);
    });
    MarkerClick(typecode, lineId, 'test', false, false);
  //  document.getElementById(`passport${lineId}`).addEventListener('click', function() {
  addSafeListener(`passport${lineId}`, function () {
          //ShowPassport(objectId, latlng, circle);
          //MarkerClick(typecode, objectId);
          OpenSideBar(true);
        });

      //  document.getElementById(`fider${lineId}`).addEventListener('click', function() {
      addSafeListener(`fider${lineId}`, function () {
        //  document.getElementById('ShowAllObjects').checked = false;
        //  showAllObjectsByZoom = false;
          UnLoadAllPoles();
          UnLoadAllLines();
          ClearShowingLinkedObjects();
          ClearShowingAllLinkedObjects();

          fetch(`${process.env.REACT_APP_BASE_URL}/api/objects_list/load_fider_by_line_id/${lineId}`, {
              method: 'GET'
              })
            .then(response => response.json())
            .then(data => {
              
                data.forEach(object => { 
          
                    const latlng = L.latLng(object.lat, object.lng);
                   // const circle = DrawPoleMarker([object.lat, object.lng], object.typecode.toString(), object.countPlafond, object.name, 1, 2, object.textPosition, null, object.id, object.linkedtp).addTo(map);
                    var circle;
                  
                      circle = DrawPoleMarker(latlng, object.typecode.toString(), object.countPlafond, object.name, 1, 2, object.textPosition, null, object.id, object.linkedtp).addTo(map);
                      PolePopupSetup(circle, object.name, object.linkedtp, object.lat, object.lng, object.id);
                    
          
                    //PolePopupSetup(circle, object.name, object.linkedtp, object.lat, object.lng, object.id);
                    PopupBehavior(circle, object.id, latlng, object.linkedtp, object.typecode, object.name);
          
                    var childObject1_1 = {
                        id: object.id,
                        name: object.name,
                        circle: circle,
                        typecode: object.typecode,
                        latlng: latlng
                      };
          
                      // Используем метод find() для поиска объекта по имени
                      var foundObject = linkedtpArray.find(function(mainObject) {
                        return mainObject.name === object.linkedtp;
                      });
                      
                      if (foundObject) {
                        //console.log('Найденный объект:', foundObject);
                        foundObject.children.push(childObject1_1);
                      } else {
                        console.log('Объект с указанным именем не найден');
                        var ppObject = {
                              id: 0,
                              name: object.linkedtp,
                              children: [],
                              lines: []
                            };
                          foundObject = ppObject;
                          linkedtpArray.push(ppObject);
                          foundObject.children.push(childObject1_1);
                      }
          
                    
                });
                //linkedtpArray[linkedtpArray.indexOf(linkedtp)] = poleArray;
                //console.log("linkedtp " + linkedtpArray.indexOf(linkedtp))
            })


          fetch(`${process.env.REACT_APP_BASE_URL}/api/lines_list/load_fider_by_line_id/${lineId}`, {
  method: 'GET'
})
  .then(response => response.json())
  .then(data => {

    data.forEach(line => {
      const {
        id, from_id, to_id, linkedtp,
        typecode, start_name, end_name,
        voltage_class, geojson
      } = line;

      // Парсим координаты из GeoJSON
      const geo = JSON.parse(geojson);
      const latlngs = geo.coordinates.map(c => [c[1], c[0]]); // Переворачиваем [lng, lat] в [lat, lng]

      // Определяем цвет линии по классу напряжения
      let line_color = 'black';
      switch (voltage_class) {
        case 128: line_color = 'orange'; break;
        case 129: line_color = 'yellow'; break;
        case 130: line_color = 'red';    break;
        case 131: line_color = 'green';  break;
        case 133: line_color = 'purple'; break;
        case 134: line_color = 'blue';   break;
        default:  line_color = 'black';  break;
      }

      // Настраиваем стиль
      const lineStyle = {
        color: line_color,
        id: id,
        from_id: from_id,
        to_id: to_id,
        linkedtp: linkedtp,
        start_name: start_name,
        end_name: end_name,
        ...(typecode == 7 && { dashArray: '7, 7' })
      };

      // Рисуем полилинию на карте
      const polyline = L.polyline(latlngs, lineStyle).addTo(map);
      polylineArray.push(polyline);

      // Формируем объект для дерева/списка связанных объектов
      const childObject1_1 = {
        id: line.id,
        line: polyline,
        start_name: start_name,
        end_name: end_name,
        from_id: from_id,
        to_id: to_id
      };

      // Ищем родительский объект по имени linkedtp
      let foundObject = linkedtpArray.find(mainObject => mainObject.name === linkedtp);

      if (foundObject) {
        foundObject.lines.push(childObject1_1);
      } else {
        console.warn(`Объект с именем ${linkedtp} не найден в дереве. Создаем новый узел.`);
        const ppObject = {
          id: 0,
          name: linkedtp,
          children: [],
          lines: [childObject1_1]
        };
        linkedtpArray.push(ppObject);
      }

      // Привязываем попап и поведение клика по линии
      LinePopupSetup(polyline, start_name, end_name, linkedtp);
      LinePopupBehavior(polyline, line.id, typecode);
    });
  })
  .catch(error => {
    console.error("Ошибка при загрузке и отрисовке линий фидера:", error);
  });


        });
    });
}
*/
export function findPolylineById(id) {
  var foundPolyline = linesData.polylineArray.find(function(polyline) {
    return polyline.options.id === id;
  });
  return foundPolyline || null;
}

export function updatePolylineByFromId(id, start_name) {
  linesData.polylineArray.find(function(polyline) {
    if(polyline.options.from_id === id) {
      polyline.options.start_name = start_name;
    }
  });
}

export function updatePolylineByToId(id, end_name) {
  linesData.polylineArray.find(function(polyline) {
    if(polyline.options.to_id === id) {
      polyline.options.end_name = end_name;
    }
  });
}

export function deletePolylineByFromId(id) {
  linesData.polylineArray.find(function(polyline) {
    if(polyline.options.from_id === id) {
      map.removeLayer(polyline);
    }
  });

  //return foundPolyline || null;
}

export function deletePolylineByToId(id) {
  linesData.polylineArray.find(function(polyline) {
    if(polyline.options.to_id === id) {
      map.removeLayer(polyline);
    }
  });

  //return foundPolyline || null;
}